import { ComponentProps } from 'react';
import cms from '../../lib/contentful';
import BlogPostPage from '../../src/components/BlogPostPage';

export async function getStaticPaths() {
  const paths = await cms.getBlogPostsPaths();
  return {
    paths: paths.map((path) => (
      { params: { slug: path.slug } }
    )),
    fallback: false,
  };
}

type Context = {
  params: {
    slug: string
  }
  preview: boolean
}

export async function getStaticProps({ params } : Context):
Promise<{props: ComponentProps<typeof BlogPostPage>}> {
  const [
    blogPostData, popularPosts, bottomPageLinks,
  ] = await cms.getBlogPostWithSlug(params.slug, false);
  const navbarData = await cms.getNavbar();
  return {
    props: {
      blogPostData,
      blogPageData: { popularPosts, bottomPageLinks },
      navbarData: navbarData.menu,
    },
  };
}

export default BlogPostPage;
